import ComplementaryProducts from '@pixelunion/pxs-complementary-products';
import ProductDetails from '../components/ProductDetails';
import ProductGallery from '../components/ProductGallery';
import PaymentTerms from '../helpers/PaymentTerms';

export default class Product {
  constructor(section) {
    this.el = section.el;
    this.sectionId = section.id;
    this.data = section.data;
    this.onboarding = this.data.onboarding;
    this.product = this.data.product;
    this.productRecommendationLimit = this.data.product_recommendation_limit;
    this.variantInventory = this.data.variantInventory;

    const complementaryProductsEl = this.el.querySelector('[data-complementary-products]');

    if (complementaryProductsEl) {
      this.complementaryProducts = new ComplementaryProducts({
        sectionEl: this.el,
        sectionId: this.sectionId,
        productId: this.product.id,
        productRecommendationsRoute: window.PXUTheme.routes.product_recommendations_url,
        includeIndicatorDots: true,
        limit: this.productRecommendationLimit,
      });
    }

    this.paymentTerms = new PaymentTerms(this.el);

    this.productGallery = new ProductGallery({
      el: this.el,
      product: this.product,
      settings: this.data,
    });

    if (this.onboarding) { return; }

    this.productDetails = new ProductDetails({
      el: this.el,
      product: this.product,
      variantInventory: this.variantInventory,
      settings: this.data,
      onVariantChange: variant => {
        this.productGallery.updateGalleryImageByVariant(variant);
        this.paymentTerms.update(variant.id);
      },
    });
  }

  unload() {
    if (this.productDetails) {
      this.productDetails.unload();
    }

    if (this.productGallery) {
      this.productGallery.unload();
    }
  }

  onSectionUnload() {
    this.unload();
  }
}
